import { Component, Input, NgModule } from '@angular/core';
import { LucideDynamicIcon, icons, provideLucideIcons } from '@lucide/angular';

@Component({
  selector: 'i-lucide',
  standalone: false,
  template: `
    @if (name) {
      <svg
        [lucideIcon]="name"
        [size]="size"
        [color]="color"
        [strokeWidth]="strokeWidth"
        [absoluteStrokeWidth]="absoluteStrokeWidth"
      ></svg>
    }
  `,
  host: {
    'class': 'lucide-host'
  }
})
export class LucideIconComponent {
  @Input() name: string | null | undefined;
  @Input() size: string | number | null = null;
  @Input() color: string | null = null;
  @Input() strokeWidth: string | number | null = null;
  @Input() absoluteStrokeWidth: boolean | null = null;
}

@NgModule({
  declarations: [
    LucideIconComponent
  ],
  imports: [
    LucideDynamicIcon
  ],
  exports: [
    LucideIconComponent
  ],
  providers: [
    provideLucideIcons(...Object.values(icons))
  ]
})
export class LucideModule { }
